(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    

  // Update quantity
  function updateQuantity(variantId, newQuantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: newQuantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      if (newQuantity === 0) {
        // Remove item from DOM without page reload
        const cartItem = document.querySelector(`[data-variant-id="${variantId}"]`);
        if (cartItem) {
          cartItem.remove();
        }
        
        // Check if cart is now empty and reload if so
        if (cart.item_count === 0) {
          location.reload();
        } else {
          updateCartDisplay(cart);
        }
      } else {
        updateCartDisplay(cart);
      }
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      // Fallback: reload on error
      location.reload();
    });
  }

  // Update cart display
  function updateCartDisplay(cart) {
    // Update totals
    document.querySelectorAll('.summary-value').forEach((el, index) => {
      if (index === 0 || index === 2) { // Subtotal and total
        el.textContent = formatMoney(cart.total_price);
      }
    });

    // Update item counts and prices
    cart.items.forEach(item => {
      const cartItem = document.querySelector(`[data-variant-id="${item.variant_id}"]`);
      if (cartItem) {
        const quantityInput = cartItem.querySelector('.quantity-input');
        const itemPrice = cartItem.querySelector('.item-price');
        const itemTotal = cartItem.querySelector('.item-total');
        
        if (quantityInput) quantityInput.value = item.quantity;
        if (itemPrice) itemPrice.textContent = formatMoney(item.price);
        if (itemTotal) {
          if (item.quantity > 1) {
            itemTotal.textContent = formatMoney(item.line_price);
            itemTotal.style.display = 'block';
          } else {
            itemTotal.style.display = 'none';
          }
        }
      }
    });

    // Update cart count badge
    const cartCountBadge = document.querySelector('.cart-count-badge');
    if (cartCountBadge) {
      cartCountBadge.textContent = cart.item_count;
    }
  }

  // Format money (simple version)
  function formatMoney(cents) {
    const symbol = window.__shopCurrencySymbol || 'CHF';
    return `${symbol} ${(cents / 100).toFixed(2)}`;
  }

  // Event listeners
  document.addEventListener('DOMContentLoaded', function() {
    // Quantity buttons and remove buttons
    document.addEventListener('click', function(e) {
      // Remove item button
      if (e.target.matches('.cart-item__remove-x') || e.target.closest('.cart-item__remove-x')) {
        e.preventDefault();
        const btn = e.target.closest('.cart-item__remove-x');
        const variantId = btn.getAttribute('data-variant-id');
        updateQuantity(variantId, 0);
        return;
      }
      if (e.target.matches('.quantity-increase') || e.target.closest('.quantity-increase')) {
        e.preventDefault();
        const btn = e.target.closest('.quantity-increase');
        const variantId = btn.getAttribute('data-variant-id');
        const input = btn.parentElement.querySelector('.quantity-input');
        const newQuantity = parseInt(input.value) + 1;
        input.value = newQuantity;
        updateQuantity(variantId, newQuantity);
      }
      
      if (e.target.matches('.quantity-decrease') || e.target.closest('.quantity-decrease')) {
        e.preventDefault();
        const btn = e.target.closest('.quantity-decrease');
        const variantId = btn.getAttribute('data-variant-id');
        const input = btn.parentElement.querySelector('.quantity-input');
        const newQuantity = Math.max(0, parseInt(input.value) - 1);
        input.value = newQuantity;
        updateQuantity(variantId, newQuantity);
      }
      
    });

    // Quantity input change
    document.addEventListener('change', function(e) {
      if (e.target.matches('.quantity-input')) {
        const input = e.target;
        const variantId = input.getAttribute('data-variant-id');
        const newQuantity = Math.max(0, parseInt(input.value) || 0);
        input.value = newQuantity;
        updateQuantity(variantId, newQuantity);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-backup"] && !Shopify.designMode) return;
  try {
    
  function scrollCategories(direction) {
    const container = document.querySelector('.categories');
    const scrollAmount = 200;
    container.scrollLeft += direction * scrollAmount;
  }

  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    // Define toggle function globally
    window.toggleDropdown = function(dropdownId) {
      const content = document.getElementById(dropdownId);
      if (!content) {
        return;
      }
      
      const dropdown = content.parentElement;
      
      // Close all other dropdowns
      document.querySelectorAll('.filter-dropdown-content').forEach(otherContent => {
        if (otherContent.id !== dropdownId) {
          otherContent.classList.remove('active');
          otherContent.parentElement.classList.remove('active');
        }
      });

      // Toggle current dropdown
      dropdown.classList.toggle('active');
      content.classList.toggle('active');
    };

    // Add click event listeners for filter buttons as fallback
    document.querySelectorAll('.filter-button').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const dropdown = this.parentElement;
        const dropdownContent = dropdown.querySelector('.filter-dropdown-content');
        if (dropdownContent) {
          window.toggleDropdown(dropdownContent.id);
        }
      });
    });
  });

  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Network response was not ok');
    })
    .then(data => {
      console.log('Product added to cart');
      // Use the global cart drawer function if available
      if (window.openCartDrawer && window.updateCartDrawerDisplay) {
        // Refresh cart and open drawer
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            window.updateCartDrawerDisplay(cart);
            window.openCartDrawer();
          });
      } else {
        // Fallback: reload page to show updated cart
        location.reload();
      }
    })
    .catch(error => {
      console.log('Error adding to cart:', error);
    });
  }

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.filter-dropdown')) {
      document.querySelectorAll('.filter-dropdown-content').forEach(content => {
        content.classList.remove('active');
        content.parentElement.classList.remove('active');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  // Currency Selector
  document.addEventListener('DOMContentLoaded', function() {
    const toggle = document.getElementById('currencyToggle');
    const dropdown = document.getElementById('currencyDropdown');

    if (!toggle || !dropdown) return;

    toggle.addEventListener('click', function(e) {
      e.stopPropagation();
      dropdown.classList.toggle('open');
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.currency-selector')) {
        dropdown.classList.remove('open');
      }
    });
  });

  // Mobile Navigation Functionality
  document.addEventListener('DOMContentLoaded', function() {
    const mobileMenuToggle = document.getElementById('mobileMenuToggle');
    const mobileNav = document.getElementById('mobileNav');
    const mobileNavOverlay = document.getElementById('mobileNavOverlay');
    const mobileNavClose = document.getElementById('mobileNavClose');

    function openMobileNav() {
      if (mobileNav && mobileMenuToggle) {
        mobileNav.classList.add('active');
        mobileMenuToggle.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeMobileNav() {
      if (mobileNav && mobileMenuToggle) {
        mobileNav.classList.remove('active');
        mobileMenuToggle.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    if (mobileMenuToggle) {
      mobileMenuToggle.addEventListener('click', function() {
        if (mobileNav.classList.contains('active')) {
          closeMobileNav();
        } else {
          openMobileNav();
        }
      });
    }

    if (mobileNavOverlay) {
      mobileNavOverlay.addEventListener('click', closeMobileNav);
    }

    if (mobileNavClose) {
      mobileNavClose.addEventListener('click', closeMobileNav);
    }

    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('active')) {
        closeMobileNav();
      }
    });
  });

  // Cart Drawer Functionality
  document.addEventListener('DOMContentLoaded', function() {
    const cartToggle = document.querySelector('.cart-toggle');
    const cartDrawer = document.querySelector('.cart-drawer');
    const cartOverlay = document.querySelector('.cart-drawer__overlay');
    const cartClose = document.querySelector('.cart-drawer__close');
    // Open cart drawer
    if (cartToggle) {
      cartToggle.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
      });
    }

    // Close cart drawer
    function closeCartDrawer() {
      if (cartDrawer) {
        cartDrawer.classList.remove('open');
        document.body.style.overflow = '';
      }
    }

    // Cart countdown timer
    var cartCountdownIv = null;
    function startCartCountdown() {
      if (cartCountdownIv) return;
      if (!window.__enableSale30 || !window.__saleEndDatetime) return;
      var endMs = new Date(window.__saleEndDatetime.replace(' ', 'T')).getTime();
      if (isNaN(endMs)) return;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var el = document.getElementById('cartCountdownTimer');
        if (!el) return;
        var diff = endMs - Date.now();
        if (diff <= 0) { el.style.display = 'none'; clearInterval(cartCountdownIv); cartCountdownIv = null; return; }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s %= 86400;
        var h = Math.floor(s / 3600); s %= 3600;
        var m = Math.floor(s / 60); s %= 60;
        el.textContent = pad(d) + ':' + pad(h) + ':' + pad(m) + ':' + pad(s);
        el.style.display = '';
      }
      tick();
      cartCountdownIv = setInterval(tick, 1000);
    }

    // Open cart drawer
    function openCartDrawer() {
      if (cartDrawer) {
        cartDrawer.classList.add('open');
        document.body.style.overflow = 'hidden';
        startCartCountdown();
      }
    }

    // Close drawer events
    if (cartClose) {
      cartClose.addEventListener('click', closeCartDrawer);
    }

    if (cartOverlay) {
      cartOverlay.addEventListener('click', closeCartDrawer);
    }

    // Close drawer on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeCartDrawer();
      }
    });

    // Checkout button (event delegation - works after cart DOM updates)
    document.addEventListener('click', function(e) {
      if (e.target.closest('.cart-drawer__checkout-btn')) {
        window.location.href = '/checkout';
      }
    });


    // Quantity update functions
    function updateQuantity(variantId, newQuantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: newQuantity
        })
      })
      .then(response => response.json())
      .then(cart => {
        if (newQuantity === 0) {
          // Remove item from drawer DOM without full reload
          const cartItem = document.querySelector(`.cart-drawer__item[data-variant-id="${variantId}"]`);
          if (cartItem) {
            cartItem.remove();
          }
          
          // If cart is now empty, update display
          if (cart.item_count === 0) {
            updateCartDrawerDisplay(cart);
          } else {
            updateCartDrawerDisplay(cart);
          }
        } else {
          updateCartDrawerDisplay(cart);
        }
      })
      .catch(error => {
        console.error('Error updating cart:', error);
        // Fallback: refresh the drawer display
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => updateCartDrawerDisplay(cart));
      });
    }

    // Update cart drawer display with smooth animations
    function updateCartDrawerDisplay(cart) {
      // Update header cart badge
      const cartBadge = document.querySelector('.cart-badge');
      if (cart.item_count > 0) {
        if (cartBadge) {
          cartBadge.textContent = cart.item_count;
          cartBadge.style.display = 'flex';
        } else {
          const cartToggle = document.querySelector('.cart-toggle');
          if (cartToggle) {
            const newBadge = document.createElement('span');
            newBadge.className = 'cart-badge';
            newBadge.textContent = cart.item_count;
            cartToggle.appendChild(newBadge);
          }
        }
      } else {
        if (cartBadge) {
          cartBadge.style.display = 'none';
        }
      }

      const drawerBody = document.querySelector('.cart-drawer__body');
      if (!drawerBody) return;

      // If cart is empty, show empty state
      if (cart.item_count === 0) {
        drawerBody.innerHTML = `
          <div class="cart-drawer__empty">
            <p>Ihr Warenkorb ist leer</p>
          </div>
        `;
        return;
      }

      const freeShippingThreshold = parseInt(drawerBody.dataset.freeShippingThreshold) || 10000;
      const remaining = freeShippingThreshold - cart.total_price;
      const progressPercent = Math.min(100, (cart.total_price / freeShippingThreshold) * 100);
      const isFreeShipping = cart.total_price >= freeShippingThreshold;

      // Check if we can do a smooth update (elements exist)
      const existingProgressFill = drawerBody.querySelector('.shipping-progress-fill');
      const existingShippingMessage = drawerBody.querySelector('.shipping-message');
      const existingSubtotal = drawerBody.querySelector('.cart-drawer__subtotal-value');
      const existingItems = drawerBody.querySelector('.cart-drawer__items');

      if (existingProgressFill && existingShippingMessage && existingSubtotal && existingItems) {
        // Smooth update - only update what changed

        // Update progress bar with animation
        existingProgressFill.style.width = progressPercent + '%';

        // Update shipping message
        if (isFreeShipping) {
          existingShippingMessage.className = 'shipping-message shipping-free';
          existingShippingMessage.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg><span><strong>Kostenloser Versand!</strong></span>';
        } else {
          existingShippingMessage.className = 'shipping-message';
          existingShippingMessage.innerHTML = `<span>Noch <strong>${formatMoney(remaining)}</strong> bis zum kostenlosen Versand</span>`;
        }

        // Update bundle progress
        updateBundleProgress(drawerBody, cart.item_count);

        // Update subtotal with animation
        existingSubtotal.style.transform = 'scale(1.1)';
        existingSubtotal.innerHTML = formatSaleSubtotal(cart);
        setTimeout(() => { existingSubtotal.style.transform = 'scale(1)'; }, 150);

        // Update individual items
        const currentItemIds = Array.from(existingItems.querySelectorAll('.cart-drawer__item')).map(el => el.dataset.variantId);
        const newItemIds = cart.items.map(item => String(item.variant_id));

        // Check if items structure changed (added/removed items)
        const itemsChanged = currentItemIds.length !== newItemIds.length ||
                            !currentItemIds.every((id, i) => id === newItemIds[i]);

        if (itemsChanged) {
          // Rebuild items with fade animation
          existingItems.style.opacity = '0.5';
          setTimeout(() => {
            rebuildCartItems(existingItems, cart);
            existingItems.style.opacity = '1';
          }, 150);
        } else {
          // Just update quantities and prices
          cart.items.forEach(item => {
            const itemEl = existingItems.querySelector(`.cart-drawer__item[data-variant-id="${item.variant_id}"]`);
            if (itemEl) {
              const qtyDisplay = itemEl.querySelector('.quantity-display');
              const priceEl = itemEl.querySelector('.cart-drawer__item-price');
              if (qtyDisplay) qtyDisplay.textContent = item.quantity;
              if (priceEl) priceEl.innerHTML = formatCartItemPrice(item);
            }
          });
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
      } else {
        // Full rebuild (first load or structure missing)
        rebuildFullCartDrawer(drawerBody, cart, freeShippingThreshold, progressPercent, remaining, isFreeShipping);
      }
    }

    function updateBundleProgress(drawerBody, itemCount) {
      if (!window.__enable3for2) return;
      var bundleContainer = drawerBody.querySelector('.cart-drawer__bundle-progress');
      if (!bundleContainer) return;

      var bundleFill = bundleContainer.querySelector('.bundle-progress-fill');
      var bundleMsg = bundleContainer.querySelector('.bundle-message');
      if (!bundleFill || !bundleMsg) return;

      if (itemCount >= 3) {
        bundleMsg.className = 'bundle-message bundle-active';
        bundleMsg.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg><span><strong>3 für 2 Aktion aktiv!</strong> Günstigstes Produkt gratis!</span>';
        bundleFill.style.width = '100%';
      } else if (itemCount === 2) {
        bundleMsg.className = 'bundle-message';
        bundleMsg.innerHTML = '<span>Noch <strong>1 Produkt</strong> bis zu deinem Gratis-Artikel!</span>';
        bundleFill.style.width = '66%';
      } else if (itemCount === 1) {
        bundleMsg.className = 'bundle-message';
        bundleMsg.innerHTML = '<span>Noch <strong>2 Produkte</strong> bis zu deinem Gratis-Artikel!</span>';
        bundleFill.style.width = '33%';
      } else {
        bundleMsg.className = 'bundle-message';
        bundleMsg.innerHTML = '<span>Lege <strong>3 Produkte</strong> in den Warenkorb — günstigstes gratis!</span>';
        bundleFill.style.width = '0%';
      }
    }

    function rebuildCartItems(container, cart) {
      let itemsHTML = '';
      cart.items.forEach(item => {
        const variantTitle = item.variant_title !== 'Default Title' ? item.variant_title : '';
        itemsHTML += `
          <div class="cart-drawer__item" data-variant-id="${item.variant_id}">
            <button type="button" class="cart-drawer__item-remove-x" data-variant-id="${item.variant_id}">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
            <div class="cart-drawer__item-image">
              ${item.image ? `<img src="${item.image}?width=80" alt="${item.title}" loading="lazy">` : ''}
            </div>
            <div class="cart-drawer__item-info">
              <div class="cart-drawer__item-details">
                <h4 class="cart-drawer__item-title">${item.product_title}</h4>
                ${variantTitle ? `<div class="cart-drawer__item-variant">${variantTitle}</div>` : ''}
                <div class="cart-drawer__item-price">${formatCartItemPrice(item)}</div>
                <div class="cart-drawer__item-quantity">
                  <button type="button" class="quantity-btn quantity-decrease" data-variant-id="${item.variant_id}">-</button>
                  <span class="quantity-display">${item.quantity}</span>
                  <button type="button" class="quantity-btn quantity-increase" data-variant-id="${item.variant_id}">+</button>
                </div>
              </div>
            </div>
          </div>
        `;
      });
      container.innerHTML = itemsHTML;
    }

    function rebuildFullCartDrawer(drawerBody, cart, threshold, progressPercent, remaining, isFreeShipping) {
      let html = '<div class="cart-drawer__shipping-top">';
      if (isFreeShipping) {
        html += `
          <div class="shipping-message shipping-free">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>
            <span><strong>Kostenloser Versand!</strong></span>
          </div>
          <div class="shipping-bar-wrapper">
            <div class="shipping-progress-bar">
              <div class="shipping-progress-fill" style="width: ${progressPercent}%"></div>
            </div>
          </div>`;
      } else {
        html += `
          <div class="shipping-message">
            <span>Noch <strong>${formatMoney(remaining)}</strong> bis zum kostenlosen Versand</span>
          </div>
          <div class="shipping-bar-wrapper">
            <div class="shipping-progress-bar">
              <div class="shipping-progress-fill" style="width: ${progressPercent}%"></div>
            </div>
          </div>`;
      }
      html += '</div>';

      // Bundle 3-for-2 progress
      if (window.__enable3for2) {
        html += '<div class="cart-drawer__bundle-progress">';
        if (cart.item_count >= 3) {
          html += '<div class="bundle-message bundle-active"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg><span><strong>3 für 2 Aktion aktiv!</strong> Günstigstes Produkt gratis!</span></div>';
          html += '<div class="bundle-bar-wrapper"><div class="bundle-progress-bar"><div class="bundle-progress-fill" style="width: 100%"></div></div></div>';
        } else if (cart.item_count === 2) {
          html += '<div class="bundle-message"><span>Noch <strong>1 Produkt</strong> bis zu deinem Gratis-Artikel!</span></div>';
          html += '<div class="bundle-bar-wrapper"><div class="bundle-progress-bar"><div class="bundle-progress-fill" style="width: 66%"></div></div></div>';
        } else if (cart.item_count === 1) {
          html += '<div class="bundle-message"><span>Noch <strong>2 Produkte</strong> bis zu deinem Gratis-Artikel!</span></div>';
          html += '<div class="bundle-bar-wrapper"><div class="bundle-progress-bar"><div class="bundle-progress-fill" style="width: 33%"></div></div></div>';
        } else {
          html += '<div class="bundle-message"><span>Lege <strong>3 Produkte</strong> in den Warenkorb — günstigstes gratis!</span></div>';
          html += '<div class="bundle-bar-wrapper"><div class="bundle-progress-bar"><div class="bundle-progress-fill" style="width: 0%"></div></div></div>';
        }
        html += '</div>';
      }

      // Sale 30% Banner with inline countdown
      if (window.__enableSale30) {
        html += '<div class="cart-drawer__sale-banner">';
        html += '<span class="sale-banner__icon">&#128293;</span>';
        html += '<div class="sale-banner__text"><strong>' + (window.__salePercent || 30) + '% SALE auf alles!</strong>';
        if (window.__saleEndDatetime) {
          html += ' <span class="sale-banner__countdown" id="cartCountdownTimer">00:00:00:00</span>';
        }
        html += '<div class="sale-banner__subtitle">Dein Rabatt wird automatisch abgezogen.</div></div>';
        html += '</div>';
      }

      html += '<div class="cart-drawer__items">';
      cart.items.forEach(item => {
        const variantTitle = item.variant_title !== 'Default Title' ? item.variant_title : '';
        html += `
          <div class="cart-drawer__item" data-variant-id="${item.variant_id}">
            <button type="button" class="cart-drawer__item-remove-x" data-variant-id="${item.variant_id}">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
            <div class="cart-drawer__item-image">
              ${item.image ? `<img src="${item.image}?width=80" alt="${item.title}" loading="lazy">` : ''}
            </div>
            <div class="cart-drawer__item-info">
              <div class="cart-drawer__item-details">
                <h4 class="cart-drawer__item-title">${item.product_title}</h4>
                ${variantTitle ? `<div class="cart-drawer__item-variant">${variantTitle}</div>` : ''}
                <div class="cart-drawer__item-price">${formatCartItemPrice(item)}</div>
                <div class="cart-drawer__item-quantity">
                  <button type="button" class="quantity-btn quantity-decrease" data-variant-id="${item.variant_id}">-</button>
                  <span class="quantity-display">${item.quantity}</span>
                  <button type="button" class="quantity-btn quantity-increase" data-variant-id="${item.variant_id}">+</button>
                </div>
              </div>
            </div>
          </div>
        `;
      });
      html += '</div>';

      html += `
        <div class="cart-drawer__recommendations" id="cart-recommendations">
          <div class="cart-recommendations__scroll"></div>
        </div>
        <div class="cart-drawer__footer">
          <div class="cart-drawer__total">
            <div class="cart-drawer__subtotal">
              <span class="cart-drawer__subtotal-label">ZWISCHENSUMME</span>
              <span class="cart-drawer__subtotal-value">${formatSaleSubtotal(cart)}</span>
            </div>
          </div>
          <div class="cart-drawer__actions">
            <button type="button" class="cart-drawer__checkout-btn">
              <span>Kasse</span>
            </button>
          </div>
        </div>
      `;

      drawerBody.innerHTML = html;
      cartCountdownIv = null;
      startCartCountdown();
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }


    // Format money function
    function formatMoney(cents) {
      var symbol = window.__shopCurrencySymbol || 'CHF';
      return symbol + ' ' + (cents / 100).toFixed(2);
    }

    function formatSaleMoney(cents, opts) {
      if (window.formatSalePrice) return window.formatSalePrice(cents, opts);
      return formatMoney(cents);
    }

    function formatCartItemPrice(item) {
      var compareAt = window.__variantCompareAt && window.__variantCompareAt[item.variant_id];
      var sym = window.__shopCurrencySymbol || 'CHF';
      if (compareAt && compareAt > item.final_price) {
        var orig = sym + ' ' + (compareAt / 100).toFixed(2);
        var sale = sym + ' ' + (item.final_price / 100).toFixed(2);
        return '<span class="sale-price-wrapper sale-price-wrapper--sm">' +
          '<span class="sale-price-original">' + orig + '</span>' +
          '<span class="sale-price-new">' + sale + '</span></span>';
      }
      if (item.original_price && item.original_price !== item.final_price) {
        var orig = sym + ' ' + (item.original_price / 100).toFixed(2);
        var sale = sym + ' ' + (item.final_price / 100).toFixed(2);
        return '<span class="sale-price-wrapper sale-price-wrapper--sm">' +
          '<span class="sale-price-original">' + orig + '</span>' +
          '<span class="sale-price-new">' + sale + '</span></span>';
      }
      return formatSaleMoney(item.final_price, {sm: true, handle: item.handle});
    }

    function formatSaleSubtotal(cart) {
      if (!window.__enableSale30) return formatMoney(cart.total_price);
      var sym = window.__shopCurrencySymbol || 'CHF';
      var origTotal = 0;
      var saleTotal = 0;
      cart.items.forEach(function(item) {
        var compareAt = window.__variantCompareAt && window.__variantCompareAt[item.variant_id];
        if (compareAt && compareAt > item.final_price) {
          origTotal += compareAt * item.quantity;
          saleTotal += item.final_line_price;
        } else if ((item.original_price && item.original_price !== item.final_price) ||
            window.isHandleExcluded(item.handle) ||
            (window.__saleMinPrice && item.final_price < window.__saleMinPrice)) {
          origTotal += item.original_line_price || item.final_line_price;
          saleTotal += item.final_line_price;
        } else {
          origTotal += item.original_line_price || item.final_line_price;
          saleTotal += window.calcSalePrice(item.final_line_price);
        }
      });
      var original = sym + ' ' + (origTotal / 100).toFixed(2);
      var sale = sym + ' ' + (saleTotal / 100).toFixed(2);
      return '<span class="sale-price-wrapper sale-price-wrapper--stacked">' +
        '<span class="sale-price-original">' + original + '</span>' +
        '<span class="sale-price-new">' + sale + '</span></span>';
    }

    // Event delegation for cart drawer buttons
    document.addEventListener('click', function(e) {
      // Remove item button
      if (e.target.matches('.cart-drawer__item-remove-x') || e.target.closest('.cart-drawer__item-remove-x')) {
        e.preventDefault();
        const btn = e.target.closest('.cart-drawer__item-remove-x');
        const variantId = btn.getAttribute('data-variant-id');
        updateQuantity(variantId, 0);
        return;
      }
      // Quantity increase
      if (e.target.matches('.cart-drawer .quantity-increase') || e.target.closest('.cart-drawer .quantity-increase')) {
        e.preventDefault();
        const btn = e.target.closest('.quantity-increase');
        const variantId = btn.getAttribute('data-variant-id');
        const quantityDisplay = btn.parentElement.querySelector('.quantity-display');
        const newQuantity = parseInt(quantityDisplay.textContent) + 1;
        quantityDisplay.textContent = newQuantity;
        updateQuantity(variantId, newQuantity);
      }
      
      // Quantity decrease
      if (e.target.matches('.cart-drawer .quantity-decrease') || e.target.closest('.cart-drawer .quantity-decrease')) {
        e.preventDefault();
        const btn = e.target.closest('.quantity-decrease');
        const variantId = btn.getAttribute('data-variant-id');
        const quantityDisplay = btn.parentElement.querySelector('.quantity-display');
        const newQuantity = Math.max(0, parseInt(quantityDisplay.textContent) - 1);
        quantityDisplay.textContent = newQuantity;
        updateQuantity(variantId, newQuantity);
      }
      
      // Remove item
    });

    // Expose functions globally
    window.openCartDrawer = openCartDrawer;
    window.updateCartDrawerDisplay = updateCartDrawerDisplay;
    window.updateCartQuantity = updateQuantity;
    
    // Add to cart functionality (for use with product forms)
    window.addToCartDrawer = function(formData) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(addedItem => {
        // Fetch product data (for compare_at_price) and cart in parallel
        var promises = [fetch('/cart.js').then(r => r.json())];
        if (addedItem.handle && (!window.__variantCompareAt || !window.__variantCompareAt[addedItem.variant_id])) {
          promises.push(
            fetch('/products/' + addedItem.handle + '.js')
              .then(r => r.json())
              .then(product => {
                if (!window.__variantCompareAt) window.__variantCompareAt = {};
                product.variants.forEach(v => { window.__variantCompareAt[v.id] = v.compare_at_price || 0; });
              })
              .catch(() => {})
          );
        }
        return Promise.all(promises).then(results => results[0]);
      })
      .then(cart => {
        updateCartDrawerDisplay(cart);
        openCartDrawer();
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('bannerSlider');
  if (!slider) return;

  const allSlides = slider.querySelectorAll('.banner-slide');
  const allDots = document.querySelectorAll('.pagination-dot');
  const prevBtn = document.getElementById('bannerPrev');
  const nextBtn = document.getElementById('bannerNext');
  const isMobile = window.innerWidth <= 768;

  // Filter out desktop-only slides on mobile
  const visibleIndices = [];
  allSlides.forEach((slide, i) => {
    if (!isMobile || !slide.classList.contains('banner-slide--desktop-only')) {
      visibleIndices.push(i);
    }
  });

  // On mobile, if the first visible slide differs from index 0, activate the correct one
  if (isMobile && visibleIndices.length > 0 && visibleIndices[0] !== 0) {
    allSlides[0].classList.remove('active');
    allSlides[visibleIndices[0]].classList.add('active');
  }

  let currentPos = 0; // position within visibleIndices
  let slideInterval;
  let isTransitioning = false;

  function showSlide(pos) {
    if (isTransitioning || pos === currentPos || pos >= visibleIndices.length) return;

    isTransitioning = true;

    // Hide current slide
    allSlides[visibleIndices[currentPos]].classList.remove('active');

    // Show new slide
    allSlides[visibleIndices[pos]].classList.add('active');
    currentPos = pos;

    // Update dots
    allDots.forEach((dot, i) => {
      dot.classList.toggle('active', i === pos);
    });

    setTimeout(() => {
      isTransitioning = false;
    }, 500);
  }

  function nextSlide() {
    const next = (currentPos + 1) % visibleIndices.length;
    showSlide(next);
  }

  function prevSlide() {
    const prev = (currentPos - 1 + visibleIndices.length) % visibleIndices.length;
    showSlide(prev);
  }

  function startAutoSlide() {
    if (visibleIndices.length > 1) {
      slideInterval = setInterval(nextSlide, 4000);
    }
  }

  function stopAutoSlide() {
    clearInterval(slideInterval);
  }

  // Event listeners
  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Next button clicked');
      nextSlide();
      stopAutoSlide();
      setTimeout(startAutoSlide, 100);
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Prev button clicked');
      prevSlide();
      stopAutoSlide();
      setTimeout(startAutoSlide, 100);
    });
  }

  allDots.forEach((dot, index) => {
    dot.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('Dot clicked:', index);
      showSlide(index);
      stopAutoSlide();
      setTimeout(startAutoSlide, 100);
    });
  });

  // Pause on hover
  slider.addEventListener('mouseenter', stopAutoSlide);
  slider.addEventListener('mouseleave', startAutoSlide);

  // Touch support for mobile
  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  });

  slider.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  });

  function handleSwipe() {
    if (touchEndX < touchStartX - 50) {
      nextSlide();
    }
    if (touchEndX > touchStartX + 50) {
      prevSlide();
    }
  }

  // Start auto-slide
  startAutoSlide();

  // Sale Countdown Timer
  (function() {
    var el = document.getElementById('saleCountdown');
    var daysEl = document.getElementById('timerDays');
    var hoursEl = document.getElementById('timerHours');
    var minsEl = document.getElementById('timerMins');
    var secsEl = document.getElementById('timerSecs');
    if (!el || !daysEl) return;
    if (!window.__enableSale30 || !window.__saleEndDatetime) return;

    var endMs = new Date(window.__saleEndDatetime.replace(' ', 'T')).getTime();
    if (isNaN(endMs)) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function update() {
      var diff = endMs - Date.now();
      if (diff <= 0) {
        el.style.display = 'none';
        var hs = el.closest('.hero-section');
        if (hs) hs.classList.remove('has-countdown');
        window.__enableSale30 = false;
        clearInterval(iv);
        return;
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s %= 86400;
      var h = Math.floor(s / 3600); s %= 3600;
      var m = Math.floor(s / 60); s %= 60;
      daysEl.textContent = pad(d);
      hoursEl.textContent = pad(h);
      minsEl.textContent = pad(m);
      secsEl.textContent = pad(s);

      // Also update cart drawer countdown if present
      var cartTimer = document.getElementById('cartCountdownTimer');
      if (cartTimer) cartTimer.textContent = pad(d) + ':' + pad(h) + ':' + pad(m) + ':' + pad(s);
    }

    update();
    el.style.display = '';
    var heroSection = el.closest('.hero-section');
    if (heroSection) heroSection.classList.add('has-countdown');
    var iv = setInterval(update, 1000);
  })();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Initialize variables from window.productData
  let selectedOptions = {};
  let productVariants = {};
  let productOptions = [];
  
  // Load data from global variable
  if (window.productData) {
    productOptions = window.productData.options || [];
    productVariants = window.productData.variants || {};
    selectedOptions = window.productData.firstVariant || {};
  }

  function updatePrice() {
    console.log('updatePrice called with selectedOptions:', selectedOptions); // Debug
    
    // Find variant based on selected options
    const variant = findVariantByOptions(selectedOptions);
    console.log('Found variant:', variant); // Debug
    
    if (variant) {
      const priceContainer = document.querySelector('.product-price');
      const cartButton = document.querySelector('.add-to-cart-btn-main');
      const variantIdInput = document.getElementById('variant-id');
      
      console.log('Updating price to:', variant.price); // Debug
      
      var currSym = window.__shopCurrencySymbol || 'CHF';
      var _prodTags = window.productData ? window.productData.tags : null;
      var _prodExcluded = _prodTags && window.isSaleExcluded(_prodTags);
      if (window.__enableSale30 && !_prodExcluded && window.formatSalePrice && variant.priceCents) {
        priceContainer.innerHTML = window.formatSalePrice(variant.priceCents, {compareAtPrice: variant.compareAtPriceCents || 0});
      } else if (variant.compareAtPrice && variant.compareAtPrice !== variant.price && variant.compareAtPrice !== currSym + ' 0.00') {
        priceContainer.innerHTML = `
          <span class="price-sale">${variant.price}</span>
          <span class="price-original">${variant.compareAtPrice}</span>
        `;
      } else {
        priceContainer.innerHTML = `
          <span class="price">${variant.price}</span>
        `;
      }
      
      // Update variant ID in form
      if (variantIdInput) {
        variantIdInput.value = variant.id;
        console.log('Updated variant ID to:', variant.id); // Debug
      }
      
      // Update cart button text
      if (cartButton) {
        if (window.__enableSale30 && !_prodExcluded && window.calcSalePrice && variant.priceCents) {
          if (variant.compareAtPriceCents && variant.compareAtPriceCents > variant.priceCents) {
            cartButton.innerHTML = `In den Warenkorb ${variant.price}`;
          } else {
            var salePrice = currSym + ' ' + (window.calcSalePrice(variant.priceCents) / 100).toFixed(2);
            cartButton.innerHTML = `In den Warenkorb ${salePrice}`;
          }
        } else {
          cartButton.innerHTML = `In den Warenkorb ${variant.price}`;
        }
      }

      // Update savings display
      var savingsEl = document.getElementById('product-savings');
      var origPrice = window.productData ? window.productData.originalPrice : null;
      if (savingsEl && origPrice) {
        // Extract numeric price from variant.price string (e.g. "CHF 29.90" -> 29.90)
        var currentNum = parseFloat(variant.price.replace(/[^0-9.,]/g, '').replace(',', '.'));
        if (!isNaN(currentNum) && origPrice > currentNum) {
          var savings = (origPrice - currentNum).toFixed(2);
          var sym = window.__shopCurrencySymbol || 'CHF';
          savingsEl.innerHTML = '<span class="original-strikethrough">' + sym + ' ' + Math.round(origPrice) + '.-</span> Spare ' + sym + ' ' + savings + ' zum Original';
          savingsEl.style.display = '';
        } else {
          savingsEl.style.display = 'none';
        }
      }
    } else {
      console.log('No variant found for selected options'); // Debug
    }
  }

  function findVariantByOptions(options) {
    console.log('findVariantByOptions called with:', options); // Debug
    console.log('Available variants:', productVariants); // Debug
    console.log('Product options:', productOptions); // Debug
    
    for (const [variantId, variant] of Object.entries(productVariants)) {
      let matches = true;
      console.log('Checking variant:', variantId, variant); // Debug
      
      for (let i = 0; i < productOptions.length; i++) {
        const optionName = productOptions[i];
        const variantOptionValue = variant.options[i];
        const selectedOptionValue = options[optionName];
        
        console.log(`Option ${i}: ${optionName} - variant: ${variantOptionValue}, selected: ${selectedOptionValue}`); // Debug
        
        if (variantOptionValue !== selectedOptionValue) {
          matches = false;
          break;
        }
      }
      
      if (matches) {
        console.log('Found matching variant:', variantId); // Debug
        return { id: variantId, ...variant };
      }
    }
    console.log('No matching variant found'); // Debug
    return null;
  }

  function updateAvailability() {
    document.querySelectorAll('.variant-option').forEach(optionGroup => {
      const buttons = optionGroup.querySelectorAll('.option-button');
      buttons.forEach(button => {
        const optionName = button.getAttribute('data-option');
        const optionValue = button.getAttribute('data-value');

        // Check if any variant with this option value is available
        const testOptions = Object.assign({}, selectedOptions);
        testOptions[optionName] = optionValue;

        let hasAvailable = false;
        for (const [variantId, variant] of Object.entries(productVariants)) {
          let matches = true;
          for (let i = 0; i < productOptions.length; i++) {
            const name = productOptions[i];
            if (testOptions[name] !== undefined && variant.options[i] !== testOptions[name]) {
              matches = false;
              break;
            }
          }
          if (matches && variant.available) {
            hasAvailable = true;
            break;
          }
        }

        button.classList.toggle('out-of-stock', !hasAvailable);
      });
    });

    // Update add-to-cart button
    const variant = findVariantByOptions(selectedOptions);
    const cartButton = document.querySelector('.add-to-cart-btn-main');
    if (cartButton && variant) {
      if (!variant.available) {
        cartButton.disabled = true;
        cartButton.textContent = 'Ausverkauft';
      } else {
        cartButton.disabled = false;
        var _avTags = window.productData ? window.productData.tags : null;
        var _avExcluded = _avTags && window.isSaleExcluded(_avTags);
        if (window.__enableSale30 && !_avExcluded && window.calcSalePrice && variant.priceCents) {
          if (variant.compareAtPriceCents && variant.compareAtPriceCents > variant.priceCents) {
            cartButton.innerHTML = 'In den Warenkorb ' + variant.price;
          } else {
            var sym = window.__shopCurrencySymbol || 'CHF';
            var salePrice = sym + ' ' + (window.calcSalePrice(variant.priceCents) / 100).toFixed(2);
            cartButton.innerHTML = 'In den Warenkorb ' + salePrice;
          }
        } else {
          cartButton.innerHTML = 'In den Warenkorb ' + variant.price;
        }
      }
    }
  }

  // Variant selection logic
  function setupOptionButtons() {
    console.log('Setting up option buttons...'); // Debug
    const buttons = document.querySelectorAll('.option-button');
    console.log('Found buttons:', buttons.length); // Debug
    
    buttons.forEach((button, index) => {
      console.log('Setting up button', index, button.getAttribute('data-value')); // Debug
      
      // Remove existing listeners
      button.removeEventListener('click', handleOptionClick);
      
      // Add new listener
      button.addEventListener('click', handleOptionClick);
    });
  }
  
  function handleOptionClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const button = e.target.closest('.option-button');
    if (!button) return;
    
    const optionName = button.getAttribute('data-option');
    const optionValue = button.getAttribute('data-value');
    
    console.log('Option clicked:', optionName, optionValue); // Debug
    
    // Remove selected class from other buttons in same option group
    document.querySelectorAll(`[data-option="${optionName}"]`).forEach(btn => {
      btn.classList.remove('selected');
      console.log('Removed selected from:', btn.getAttribute('data-value')); // Debug
    });
    
    // Add selected class to clicked button
    button.classList.add('selected');
    console.log('Added selected to:', optionValue); // Debug
    
    // Update selected options
    selectedOptions[optionName] = optionValue;
    
    console.log('Selected options:', selectedOptions); // Debug
    
    // Update price and availability
    updatePrice();
    updateAvailability();
  }


  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded'); // Debug
    
    // Small delay to ensure all elements are rendered
    setTimeout(function() {
      console.log('Initializing after timeout'); // Debug
      
      // Setup option button event listeners
      setupOptionButtons();
      
      // If no selected options set, select first option of each group
      if (Object.keys(selectedOptions).length === 0) {
        console.log('No pre-selected options, selecting first options...'); // Debug
        document.querySelectorAll('.variant-option').forEach(optionGroup => {
          const firstButton = optionGroup.querySelector('.option-button');
          if (firstButton) {
            const optionName = firstButton.getAttribute('data-option');
            const optionValue = firstButton.getAttribute('data-value');
            selectedOptions[optionName] = optionValue;
            firstButton.classList.add('selected');
            console.log('Auto-selected:', optionName, optionValue); // Debug
          }
        });
      } else {
        // Set default selected options in UI
        for (const [optionName, optionValue] of Object.entries(selectedOptions)) {
          const button = document.querySelector(`[data-option="${optionName}"][data-value="${optionValue}"]`);
          if (button) {
            button.classList.add('selected');
            console.log('Default selected:', optionName, optionValue); // Debug
          }
        }
      }
      
      updatePrice();
      updateAvailability();
    }, 200); // Increased timeout
    
    // Handle add to cart form submission
    const addToCartForm = document.querySelector('.add-to-cart-form');
    if (addToCartForm) {
      addToCartForm.addEventListener('submit', function(e) {
        e.preventDefault(); // Prevent default form submission
        
        // Track excluded handles for cart drawer
        if (window.productData && window.isSaleExcluded(window.productData.tags) && window.__saleExcludedHandles) {
          window.__saleExcludedHandles.add(window.productData.handle);
        }

        // Cache compare_at_price for cart drawer
        if (window.productData && window.productData.variants) {
          if (!window.__variantCompareAt) window.__variantCompareAt = {};
          Object.keys(window.productData.variants).forEach(function(vid) {
            var v = window.productData.variants[vid];
            window.__variantCompareAt[vid] = v.compareAtPriceCents || 0;
          });
        }

        const formData = new FormData(addToCartForm);
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;

        // Add to cart using drawer functionality
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: quantity
            }]
          })
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Failed to add to cart');
        })
        .then(data => {
          console.log('Product added to cart');
          // Open cart drawer if functions are available
          if (window.openCartDrawer && window.updateCartDrawerDisplay) {
            // Refresh cart data and open drawer
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                window.updateCartDrawerDisplay(cart);
                window.openCartDrawer();
              });
          } else {
            // Fallback: redirect to cart page
            window.location.href = '/cart';
          }
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          alert('Error adding product to cart. Please try again.');
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
